import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Block, DefaultText, MediumText, SelectOption, TextAreaBox, TextBox } from '@guryou/html-components';
import { CREATE_SESSION, PROVIDER_GET_CLASSES, resetState, stateIsLoading, useGender, useServiceCategories } from '@guryou/redux';
import GenderRadio from 'onboard/components/GenderRadio';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';

import StepButtons from '../StepButtons';

const getRecurring = type => {
  if (type === 'service') {
    return 'N';
  }
  if (type === 'course') {
    return 'Y';
  }
  if (type === 'event') {
    return 'E';
  }
  return null;
};

const CourseGeneralInformation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { courseState, setCourseState, serviceType } = useOnboardContext();
  const genderOptions = useGender(true);

  const categories = useServiceCategories({ type: serviceType });

  const handleSubmit = data => {
    setCourseState({ ...data, recurring: getRecurring(serviceType), type: serviceType });
    dispatch(resetState(CREATE_SESSION));
    dispatch(resetState(PROVIDER_GET_CLASSES));
  };

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t(`ONBOARD.${serviceType}Title`)} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <TextBox
            xs={12}
            fullWidth
            label={t(`ONBOARD.${serviceType}Name`)}
            margin="10px 0px 20px 0px"
            name="serviceName"
            value={courseState.serviceName}
            required
          />
          <TextAreaBox
            xs={12}
            fullWidth
            rows="6"
            margin="10px 0px 20px 0px"
            required
            name="description"
            label={t('ONBOARD.description')}
            value={courseState.description}
          />
          <SelectOption
            name="svcTypeId"
            disabled={stateIsLoading(categories)}
            xs={12}
            required
            fullWidth
            label={t('ONBOARD.category')}
            value={courseState.svcTypeId}
            margin="10px 0px 20px 0px"
            none={false}
            options={categories?.data}
          />
          <GenderRadio options={genderOptions} value={courseState.target} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText>{t('ONBOARD_TEXT.courseGeneralInformationTitle')}</MediumText>
        <DefaultText fontSize="1.2rem">{t('ONBOARD_TEXT.courseGeneralInformationSubtitle')}</DefaultText>
        <Block margin={0} marginTop={10}>
          <DefaultText fontSize="1.2rem" fontWeight="800">
            {t('ONBOARD_TEXT.courseGeneralInformationCheckboxTitle')}
          </DefaultText>
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox1Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox2Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox3Text')} />
        </Block>
        <PlayGuideVideoEmbed videoId={guideVideos[`${serviceType}GeneralInfo`].videoId} modalTitle={guideVideos[`${serviceType}GeneralInfo`].title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default CourseGeneralInformation;
